// extracted by mini-css-extract-plugin
export default {"l":"_01022e773a"};